import React from 'react';
import ReactDOM from 'react-dom';
import xr from './xr';
import queryString from 'query-string';
import { App, addIframes, prepareProps } from './App';
import { fit } from './fitToWindow';

function render() {
  const qs = queryString.parse(window.location.search);

  xr.get(`/api/kiosk/${qs['instance'] || '1'}/`).then(resp => {
    let props = prepareProps(resp.data);
    window.KIOSK = props['kiosk_id'];
    window.KIOSK_INSTANCE = props['kiosk_instance_id'];
    window.LANDSCAPE = props['is_landscape'];

    if (window.KIOSK_INSTANCE) {
      sendInit(qs['instance']);
    }

    if (!window.LANDSCAPE) {
      import('./css/kiosk.css');
      fit(document.getElementById('wrap'), 1080, 1920, ()=>{});
    } else {
      import('./css/kiosk.landscape.css');
      fit(document.getElementById('wrap'), 1920, 1080, ()=>{});
    }

    // if (process.env.NODE_ENV !== 'development') addCss(props.css);

    addIframes(props.extra, props.games, props.home_banners);
    ReactDOM.render(<App {...props} />, document.getElementById("app"));
  });
}

render();

async function sendInit(instance) {
  let internet = true;
  try {
    await timeout(5000, fetch('https://www.facebook.com/'));
  } catch (e) {
    internet = !e.isTimeout;
  }

  xr.post(`/api/kiosk/${instance}/`, {
    domain: window.location.host,
    internet,
  });
}

function timeout(ms, promise) {
  return new Promise(function(resolve, reject) {
    setTimeout(function() {
      let error = new Error("timeout");
      error.isTimeout = true;
      reject(error)
    }, ms)
    promise.then(resolve, reject)
  })
}

function addCss(css) {
  let head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style');

  head.appendChild(style);

  style.type = 'text/css';
  style.appendChild(document.createTextNode(css));
}

